module.exports = __webpack_public_path__ + "img/sports.dd71a3d1.jpg";